import React from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from 'antd';
import 'antd/es/row/style/css';
import 'antd/es/col/style/css';
import ReactLoading from 'react-loading';
import LoaderImage from "images/icons/loader.png";
import Styles from "./Loader.module.scss";

const Loader: React.FC<{ isVisible?: boolean }> = ({ isVisible }) => {
  return (
    <Row
      justify="center"
      align="middle"
      style={{ marginTop: 32, display: isVisible ? 'flex' : 'none' }}
    >
      <Col>
        <KickImage src={LoaderImage} className={Styles['loader-image']}/>
      </Col>
    </Row>
  );
};

export default Loader;